export default {
  BASE_URL: 'psm/qc/yxqcxz/admin',
  api: [
    {
      name: 'listForSubmitted',
      desc: '获取待审核列表',
      method: 'GET',
      path: '/listForSubmitted'
    },

    {
      name: 'listForAudited',
      desc: '获取已审核列表',
      method: 'GET',
      path: '/listForAudited'
    },
    {
      name: 'listForApproved',
      desc: '获取已评审列表',
      method: 'GET',
      path: '/listForApproved'
    },
    {
      name: 'listForReject',
      desc: '获取驳回列表',
      method: 'GET',
      path: '/listForReject'
    },{
      name: 'listForWaitCer',
      desc: '获取待发证列表',
      method: 'GET',
      path: '/listForWaitCer'
    },
    {
      name: 'export',
      desc: '导出',
      method: 'POST',
      path: '/export'
    },
    {
      name: 'audit',
      desc: '审批',
      method: 'POST',
      path: '/auditForSubmitted'
    },
    {
      name: 'approved',
      desc: '审批',
      method: 'POST',
      path: '/auditForApproved'
    }    
    ,{
      name: 'history',
      desc: '历史申报',
      method: 'GET',
      path: '/history'
    }
    ,{
      name: 'wait-cer',
      desc: '设置待发证',
      method: 'POST',
      path: '/auditForWaitCer'     
    },
    {
      name:'declare-update',
      desc: '更新申报信息',
      method: 'POST',
      path: '/update'
    },{
      name:'query-company',
      desc:'获取公司名称',
      method:'GET',
      path:'/company'
    }
    ,{
      name:'update-batch',
      desc:'批量更新',
      method:'POST',
      path:'/updateBatch'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/psm/qc/excellence.js